import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router';
import {authLogout} from '../../redux/AuthActionCreaters'
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        logout: () => {
            dispatch(authLogout())
        }
    }
}

class Logout extends Component{
    componentDidMount(){
        this.props.logout();
    }
    render(){
        return(
            <Redirect to="/" />
        )
    }
}
export default connect(null,mapDispatchToProps)(Logout);